var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    style: !_vm.bottom ? "" : " margin-bottom: 20px;"
  }, [_c("div", {
    staticClass: "title-box",
    staticStyle: {
      position: "relative"
    },
    style: _vm.background ? " padding: 0" : "background: #eee;"
  }, [_c("div", {
    staticClass: "leftBox"
  }, [_c("span", {
    staticClass: "title"
  }, [_vm._t("title")], 2), _c("div", [_vm._t("handle")], 2)]), _c("div", [_vm._t("btn")], 2), _c("div", {
    staticClass: "des"
  }, [_vm._t("des")], 2)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };